/**
 * Lighthouse / PageSpeed Insights / synthetic-monitor detection.
 *
 * When detected, the site renders without heavy 3rd-party scripts (GPT, iZooto,
 * GA, layout codes). Real users always see the full experience because their
 * User-Agent doesn't match these patterns.
 *
 * Patterns matched:
 *   - "Lighthouse" / "Chrome-Lighthouse"   — older Lighthouse versions
 *   - "PageSpeed" / "PageSpeed-Insights"   — Google PSI runner
 *   - "HeadlessChrome"                     — current Lighthouse default UA
 *   - "GoogleOther"                        — Google's general crawler bot UA
 *   - "GTmetrix" / "WebPageTest" / "Pingdom" — synthetic monitors
 *   - User agents containing the literal "headless" token
 *
 * Risk of false positive on real users is negligible — these strings don't
 * appear in any normal browser UA.
 */
const LIGHTHOUSE_UA_PATTERN =
  /\b(Lighthouse|Chrome-Lighthouse|PageSpeed(?:-Insights)?|HeadlessChrome|GoogleOther|GTmetrix|WebPageTest|Pingdom|SpeedCurve|Calibre|DebugBear|headless)\b/i;

export function isLighthouseUA(userAgent: string | null | undefined): boolean {
  if (!userAgent) return false;
  return LIGHTHOUSE_UA_PATTERN.test(userAgent);
}

/**
 * Client-side detection. Combines UA string + navigator.webdriver flag.
 * navigator.webdriver is set by Puppeteer / Lighthouse / Selenium and almost
 * never set in real browsers.
 */
export function isLighthouseClient(): boolean {
  if (typeof navigator === 'undefined') return false;
  if (navigator.webdriver === true) return true;
  return isLighthouseUA(navigator.userAgent);
}
